import React from "react";
import "./LegalPages.css";

function PrivacyPolicyPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">Privacy Policy</h1>
        <p className="legal-subtitle">Last updated: March 21, 2026</p>

        <section className="legal-section">
          <h2>Introduction</h2>
          <p>
            We value your privacy. This policy explains how JAPAKING collects, uses, stores, and
            shares personal and non-personal information when you use our website and application.
            By using our services, you agree to this Privacy Policy.
          </p>
        </section>

        <section className="legal-section">
          <h2>Information We Collect</h2>
          <ul>
            <li>Account data such as name and email address.</li>
            <li>Learning activity data such as usage time and answer accuracy.</li>
            <li>Shared information posted by users inside the service.</li>
            <li>Technical data collected through cookies, logs, and analytics tools.</li>
          </ul>
          <p>
            We do not intentionally collect live location data as a mandatory data field for normal
            service use.
          </p>
        </section>

        <section className="legal-section">
          <h2>How We Use Information</h2>
          <ul>
            <li>To provide and improve JAPAKING services.</li>
            <li>To support security, fraud detection, and platform reliability.</li>
            <li>To personalize learning experience and relevant communication.</li>
            <li>To send service notifications, updates, and support messages.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Sharing of Information</h2>
          <p>
            We do not sell personal information. Data may be shared with service providers,
            affiliates, or legal authorities only when needed for service operation, compliance,
            or legal obligations.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Security & Retention</h2>
          <p>
            We use reasonable technical and organizational safeguards, including encryption where
            appropriate. Personal data is retained only as long as needed for service and legal
            purposes.
          </p>
        </section>

        <section className="legal-section">
          <h2>Your Rights</h2>
          <p>
            You may request correction, update, or removal of your personal information by
            contacting our privacy contact.
          </p>
        </section>

        <div className="legal-footer-note">
          Privacy Contact: ishan@erishsolutions.com
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
